import { useMemo, useState } from 'react';

const keysToValidate = [
  'agioNConv',
  'agioNEConv',
  'agioNEI0',
  'agioNEI50',
  'agioNEI100',
  'agioNI0',
  'agioNI50',
  'agioNI100',
  'agioSConv',
  'agioSECOConv',
  'agioSECOI0',
  'agioSECOI50',
  'agioSECOI100',
  'agioSI0',
  'agioSI50',
  'agioSI100',
];

export function useAgioForm(options) {
  const { status, values, onChange } = options;

  const [changed, setChanged] = useState(false);
  const [error, setError] = useState({});

  const isSalvarEnabled = useMemo(() => {
    return changed && status !== 'loading';
  }, [changed, status]);

  function isFormValid() {
    let isValid = true;

    keysToValidate.forEach(key => {
      if (values[key] === '') {
        setError(prev => ({
          ...prev,
          [key]: 'Campo vazio',
        }));

        isValid = false;
      }
    });

    return isValid;
  }

  function handleOnChange(e) {
    const { name, value } = e.target;

    setChanged(true);

    onChange({
      target: {
        name,
        value: value ?? '',
      },
    });

    setError(prev => ({
      ...prev,
      [name]: undefined,
    }));
  }

  return { isSalvarEnabled, error, isFormValid, handleOnChange, changed, setChanged };
}
